import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'
import Swiper, { A11y, Navigation, Mousewheel, FreeMode } from 'swiper'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
Swiper.use([A11y, Navigation, Mousewheel, FreeMode])

const SELECTORS = {
  carousel: '.js-video-carousel',
  swiper: '.js-video-carousel__swiper',
  mediaVideoWrapper: '.js-video-carousel-media-video-wrapper',
  mediaVideoButton: '.media-video__info-container .unlocked-button',
  navNext: '.js-swiper_nav--next',
  navPrev: '.js-swiper_nav--prev'
}

class VideoCarousel {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.swiper = this.element.querySelector(SELECTORS.swiper)
    this.navNext = this.element.querySelector(SELECTORS.navNext)
    this.navPrev = this.element.querySelector(SELECTORS.navPrev)
    this.slideshow = null
    this.throttleResize = null
    this.isStart = true
    this.isEnd = false
    this.init()
  }

  init() {
    this.goToFirstBound = this.goToFirst.bind(this)
    this.goToLastBound = this.goToLast.bind(this)

    // Play/pause media videos by clicking them.
    this.element.querySelectorAll(SELECTORS.mediaVideoWrapper).forEach(videoWrapper => {
      videoWrapper.addEventListener('click', () => {
        this.toggleVideoState(videoWrapper)
      })
    })

    this.createCarousel()
  }

  setAriaHidden(swiper) {
    swiper.slides.forEach(element => {
      element.ariaHidden = true
    })

    swiper.slides[swiper.activeIndex].ariaHidden = false
  }

  createCarousel() {
    if (this.swiper.scrollWidth > this.swiper.offsetWidth) {
      this.carousel = new Swiper(this.swiper, {
        allowTouchMove: true,
        centeredSlides: false,
        a11y: false,
        slidesPerView: 1.25,
        spaceBetween: 15,
        navigation: {
          nextEl: this.navNext,
          prevEl: this.navPrev
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1
        },
        freeMode: {
          enabled: true,
          sticky: true,
          momentumBounce: false
        },
        slidesOffsetAfter: 15,
        breakpoints: {
          768: {
            slidesOffsetAfter: 32,
            spaceBetween: 32,
            slidesPerView: 'auto'
          }
        }
      })
      this.element.classList.add('video-carousel--swiper')
    } else {
      this.element.classList.add('video-carousel--no-swiper')
    }
  }

  setRolloverEvents(isFirst, isLast) {
    this.carousel.navigation.nextEl.removeEventListener('click', this.goToFirstBound)
    this.carousel.navigation.prevEl.removeEventListener('click', this.goToLastBound)

    if (isLast) {
      this.carousel.navigation.nextEl.addEventListener('click', this.goToFirstBound)
    }

    if (isFirst) {
      this.carousel.navigation.prevEl.addEventListener('click', this.goToLastBound)
    }
  }

  goToFirst() {
    this.carousel.slideTo(0)
  }

  goToLast() {
    this.carousel.slideTo(this.carousel.slides.length - 1)
  }

  toggleVideoState(videoWrapper) {
    const video = videoWrapper.querySelector('video')
    const button = videoWrapper.querySelector(SELECTORS.mediaVideoButton)
    if (!video) {
      return
    }

    // Pause or play?
    if (videoWrapper.classList.contains('-playing')) {
      video.pause()
      videoWrapper.classList.remove('-playing')
      button.querySelector('.unlocked-button__pause-icon')?.classList.add('-hide')
      button.querySelector('.unlocked-button__icon')?.classList.remove('-hide')
    } else {
      video.play()
      videoWrapper.classList.add('-playing')
      video.closest('.js-has-poster')?.classList.add('--hide-poster')
      button.querySelector('.unlocked-button__icon')?.classList.add('-hide')
      button.querySelector('.unlocked-button__pause-icon')?.classList.remove('-hide')
    }
  }
}

export default {
  selector: SELECTORS.carousel,
  Source: VideoCarousel
}
